module.exports = __webpack_public_path__ + "static/media/gif.dde640a2.gif";